import SectorQueue from './SectorQueue'

function Finishing() {
    return <SectorQueue sector="Acabamento" />
}

export default Finishing
